angular.module('app.directives').directive('vpHistory', ($window, $translate, $timeout, api) => ({
    restrict: 'EA',

    scope: {
        for: '=?',
        model: '@?',
        modelId: '@?',
        hideDates: '@?',
    },

    controller($scope) {
        $scope.loaded = false;
        $scope.history = [];

        if ('object' === typeof $scope.for) {
            // przekazanie obiektu
            $scope.$watch('for', (modelData) => {
                if (modelData._model) {
                    $scope.modelData = modelData;
                    $scope.model = modelData._model;
                    $scope.modelId = modelData.id;

                    $scope.refresh();
                }
            });
        } else {
            // przekazanie opisu obiektu
            $scope.modelData = $scope.$parent[$scope.model] || {};

            $scope.$watch('modelId', (newValue) => {
                if (0 < newValue || 'all' === newValue) {
                    $scope.refresh();
                }
            });
        }

        $scope.refresh = () => {
            const HistoryModel = api(`history/${$scope.model}`);

            HistoryModel.get($scope.modelId).then((data) => {
                angular.forEach(data, (row) => {
                    const isDict = row.field && '_id' === row.field.substr(-3, 3);
                    const isDate = row.field && row.field.includes('date');
                    const isSymbol = row.field && row.field.includes('code');
                    const isNumber = row.field && 0 < parseFloat(row.from_value);
                    let diff;

                    row.diff = '';
                    row.changed_at_desc = $window.timeago.format(row.changed_at);

                    // wartość słownikowa/data/liczba
                    if (isDict || isSymbol || isDate || isNumber) {
                        diff = [
                            { removed: true, value: row.from_value || '' },
                            { added: true, value: row.to_value || '' },
                        ];
                    } else {
                        diff = JsDiff.diffWordsWithSpace(row.from_value || '', row.to_value || '');
                    }

                    diff.forEach((part) => {
                        let elCls = 'part-unchanged';
                        if (part.added) {
                            elCls = 'part-added';
                        } else if (part.removed) {
                            elCls = 'part-removed';
                        }

                        row.diff += `<span class="${elCls}">${part.value}</span>`;
                    });
                });

                $scope.history = data;
                $scope.loaded = true;
            });
        };
    },

    templateUrl: '/directives/history/history.html',
}));
